<template>
	<div class="plate_text cursor-pointer" :class="{ highlighted: selected }" @click="$emit('click', plate_code)">
		<div><span :style="getPercentStyle(pct)">{{plate_name+" "+c_num}}</span></div>
		<div v-if="is_show_row2"><span>{{num1}}</span>(<span :style="{ color: num2 > 0 ? 'red' : 'green' }">{{ num2 > 0 ? '+' + num2 : num2 }}</span>)</div>
	</div>
</template>

<script>
	export default {
		props: {
			plate_code: String,
			plate_name: String,
			pct: Number,
			c_num: [Number, String],
			selected: Boolean,
			num1: [Number, String],
			num2: [Number, String],
			is_show_row2: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {

			};
		},
		computed: {

		},
		methods: {

			getGradientColor(start_color, end_color, percent) {
				// strip the leading # if it's there
				start_color = start_color.replace(/^\s*#|\s*$/g, '');
				end_color = end_color.replace(/^\s*#|\s*$/g, '');

				// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
				if (start_color.length == 3) {
					start_color = start_color.replace(/(.)/g, '$1$1');
				}

				if (end_color.length == 3) {
					end_color = end_color.replace(/(.)/g, '$1$1');
				}

				// get colors
				function parse(rgb, i) {
					return parseInt(rgb.substr(i, 2), 16)
				}

				let start_r = parse(start_color, 0),
					start_g = parse(start_color, 2),
					start_b = parse(start_color, 4);

				let end_r = parse(end_color, 0),
					end_g = parse(end_color, 2),
					end_b = parse(end_color, 4);

				// calculate new color
				let r = end_r - start_r;
				let g = end_g - start_g;
				let b = end_b - start_b;

				r = ((r * percent) + start_r)
				g = ((g * percent) + start_g)
				b = ((b * percent) + start_b)

				function hex(x) {
					let h = x.toString(16).split('.')[0].toUpperCase()
					return (h.length == 1) ? '0' + h : h
				}

				return '#' + hex(r) + hex(g) + hex(b)
			},

			getPercentColor(pt) {
				if (pt >= 0) {
					if (pt > +10) {
						pt = +10;
					}
					pt = +pt / 10;
					return this.getGradientColor('#FFFFFF', '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10;
					}
					pt = -pt / 10;
					return this.getGradientColor('#FFFFFF', '#278B22', pt)
				}
			},

			getPercentStyle(pt) {
				return {
					'background': this.getPercentColor(pt)
				}
			},
		}

	}
</script>

<style>
	.plate_text {
		border: 1px solid lightgray;
		/* font-size: 80%; */
	}

	.highlighted {
		background-color: gold;
		border: 1px solid red;
	}
</style>